const entryInput = /[^A-Za-z0-9\s\.\,\-\@\/\&\'\"\(\)\#\$\%\*\:\`\<\>\=\+\!\?]+/

function getMessage(field, args) {
  return `The ${field} consist of invalid characters.`
}

function validate(value, args) {
  if (value) {
    return !(entryInput.test(value))
  } else {
    return true
  }
}

export default {
  getMessage,
  validate
}
